export enum ActionTypeEnum {
  default = 0,
  update_state = 1,
  transition = 2,

  create_dossier = 5,
  update_dossier = 6,

  notification = 10,
  notification_comment = 12,
  delete_dossier = 15,
}
